import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type InsertBatchJobMutationVariables = Types.Exact<{
  jobs: Array<Types.Batch_Jobs_Insert_Input> | Types.Batch_Jobs_Insert_Input;
}>;


export type InsertBatchJobMutation = { __typename?: 'mutation_root', insert_batch_jobs?: { __typename?: 'batch_jobs_mutation_response', affected_rows: number } | null };


export const InsertBatchJobDocument = gql`
    mutation insertBatchJob($jobs: [batch_jobs_insert_input!]!) {
  insert_batch_jobs(objects: $jobs) {
    affected_rows
  }
}
    `;
export type InsertBatchJobMutationFn = Apollo.MutationFunction<InsertBatchJobMutation, InsertBatchJobMutationVariables>;

/**
 * __useInsertBatchJobMutation__
 *
 * To run a mutation, you first call `useInsertBatchJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertBatchJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertBatchJobMutation, { data, loading, error }] = useInsertBatchJobMutation({
 *   variables: {
 *      jobs: // value for 'jobs'
 *   },
 * });
 */
export function useInsertBatchJobMutation(baseOptions?: Apollo.MutationHookOptions<InsertBatchJobMutation, InsertBatchJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertBatchJobMutation, InsertBatchJobMutationVariables>(InsertBatchJobDocument, options);
      }
export type InsertBatchJobMutationHookResult = ReturnType<typeof useInsertBatchJobMutation>;
export type InsertBatchJobMutationResult = Apollo.MutationResult<InsertBatchJobMutation>;
export type InsertBatchJobMutationOptions = Apollo.BaseMutationOptions<InsertBatchJobMutation, InsertBatchJobMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/moves/queries/insertBatchJob.mutation.gql}
 */
export async function insertBatchJob(
  variables: InsertBatchJobMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertBatchJobMutation['insert_batch_jobs']>
export async function insertBatchJob(
  variables: InsertBatchJobMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertBatchJobMutation>
export async function insertBatchJob(
  variables: InsertBatchJobMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertBatchJobMutation['insert_batch_jobs'] | InsertBatchJobMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertBatchJobMutation>(
    InsertBatchJobDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_batch_jobs
}